import { TExportSelectedData } from './export-data';

export const site_plan_data: TExportSelectedData[] = [];
